import { createSelector } from "@reduxjs/toolkit";

import { nodeDesignsStateSelector, type NautilusDesignerState } from "../managed/index.ts";

const triggersStateSelector = createSelector(nodeDesignsStateSelector, (state) => state.triggerDesigns);

export const responsesByIdSelector = createSelector(triggersStateSelector, (state) => state.responsesById);

export const conditionIdsByResponseIdSelector = createSelector(
  triggersStateSelector,
  (state) => state.conditions.idByResponseId,
);

export const triggerIdsStateSelector = createSelector(triggersStateSelector, (state) => state.ids);

export const triggersByIdSelector = createSelector(triggersStateSelector, (state) => state.triggersById);

export const handlersByIdSelector = createSelector(triggersStateSelector, (state) => state.handlersById);

export const handlersIdsSelector = createSelector(triggerIdsStateSelector, (ids) => ids.handlerIdsByTriggerId);

export const effectsStateSelector = createSelector([triggersStateSelector], (state) => state.effects);

export const effectsByIdSelector = createSelector([effectsStateSelector], (effects) => effects.byId);

export const conditionsStateSelector = createSelector([triggersStateSelector], (state) => state.conditions);

export const buildableNameSelector = (_state: NautilusDesignerState, param: { buildableName: string }) =>
  param.buildableName;

const nodeIdParamSelector = (_state: NautilusDesignerState, param: { nodeId: number }) => param.nodeId;

export const triggersForNodeSelector = createSelector(
  [triggerIdsStateSelector, triggersByIdSelector, handlersByIdSelector, nodeIdParamSelector],
  (idsState, byId, handlersById, nodeId) => {
    const ids = idsState.triggerIdsByNodeId[nodeId] ?? [];

    return ids.map((triggerId) => {
      const handlers = (idsState.handlerIdsByTriggerId[triggerId] ?? []).map((handlerId) => ({
        ...handlersById[handlerId],
      }));
      return { ...byId[triggerId], id: triggerId, handlers };
    });
  },
);

const eventTypeParamSelector = (_state: NautilusDesignerState, param: { eventType: string }) => param.eventType;

export const triggersForEventTypeSelector = createSelector(
  [triggersForNodeSelector, eventTypeParamSelector],
  (triggers, eventType) => triggers.filter((t) => t.cases.some((c) => c.eventType === eventType)),
);

const responseIdParamSelector = (_state: NautilusDesignerState, param: { responseId: number | undefined | null }) =>
  param.responseId;

export const responseIdExistsSelector = createSelector(
  [responsesByIdSelector, responseIdParamSelector],
  (responsesById, responseId) => responseId && responseId in responsesById,
);
